var moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(869), __webpack_require__.e(884), __webpack_require__.e(191), __webpack_require__.e(979), __webpack_require__.e(131), __webpack_require__.e(422), __webpack_require__.e(94), __webpack_require__.e(894), __webpack_require__.e(112)]).then(() => (() => ((__webpack_require__(81344)))));
	},
	"./version": () => {
		return __webpack_require__.e(438).then(() => (() => ((__webpack_require__(59438)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});